import { ToastContainer } from "react-toastify";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { DirectionProvider } from "@radix-ui/react-direction";
import ReactQueryProvider from "./lib/provider/react-query-provider/react-query-provider";

function App() {
  return (
    <DirectionProvider dir="rtl">
      <ReactQueryProvider>
        <RouterProvider router={router} />
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          limit={3}
        />
      </ReactQueryProvider>
    </DirectionProvider>
  );
}

export default App;
